import { PulsarPayload } from "ExtendiApp"

import { LineChartData } from "src/ui/components/Charts/LineChart"

export const fromPulsarPayloadToLineChart = (
  dataPayload: PulsarPayload,
  legend: string[]
): LineChartData => {
  const sorted = dataPayload.map(item =>
    item.breakdown.sort((a, b) => (a.date > b.date ? 1 : -1))
  )

  const graphData = sorted[0].reduce((acc, current, idx) => {
    const expressionA = dataPayload[0].expression.split(" ")[0]
    const expressionB = dataPayload[1]
      ? dataPayload[1].expression.split(" ")[0]
      : undefined
    const expressionC = dataPayload[2]
      ? dataPayload[2].expression.split(" ")[0]
      : undefined

    const legendA = legend && legend[0] ? legend[0] : expressionA
    const legendB = legend && legend[1] ? legend[1] : expressionB
    const legendC = legend && legend[2] ? legend[2] : expressionC

    const valueA = current.value
    const valueB =
      sorted[1] && sorted[1][idx] ? sorted[1][idx].value : undefined
    const valueC =
      sorted[2] && sorted[2][idx] ? sorted[2][idx].value : undefined

    return [
      ...acc,
      {
        date: new Date(current.date),
        legendA,
        legendB,
        legendC,
        valueA,
        valueB,
        valueC,
      },
    ]
  }, [])

  return graphData
}

const formatDate = (dateString: string) => {
  const date = new Date(dateString)

  const month = date.toLocaleDateString("en-GB", {
    month: "short",
  })

  const day = date.getDate()
  const year = date.getFullYear()

  return `${month} ${day}, ${year}`
}

export const dateRangeStringFromPulsarPayload = (
  dataPayload: PulsarPayload
): string => {
  const dateArray = dataPayload.map(item =>
    item.breakdown
      .sort((a, b) => (a.date > b.date ? 1 : -1))
      .map(item => item.date)
  )[0]

  const firstDate = formatDate(dateArray[0])
  const lastDate = formatDate(dateArray.reverse()[0])
  return `${firstDate} - ${lastDate}`
}

export const getTotalTweetsFromPulsarPayload = (
  dataPayload: PulsarPayload
): string => {
  const grandTotal = dataPayload
    .map(item => {
      const total = item.breakdown.map(o => o.value).reduce((a, b) => a + b, 0)
      return total
    })
    .reduce((a, b) => a + b, 0)

  const roundedNumber =
    grandTotal > 1000000
      ? `${Math.floor(grandTotal / 1000000)}M+`
      : grandTotal > 1000
      ? `${Math.floor(grandTotal / 1000)}K+`
      : grandTotal

  return `${roundedNumber} TWEETS`
}
